<template>
    <a v-if="btnText" href="#app" class="back-to-top-btn">
        {{btnText}} <el-icon v-if="showIcon"><Top /></el-icon>
    </a>
</template>

<script>
import { Top } from '@element-plus/icons-vue';

export default {
    name: 'BackToTop',
    props: ['btnText', 'showIcon'],
    components: {
        Top
    },
    data() {
        return {

        }
    }
}
</script>